const AppConfig = {
  BACKEND_URL: 'https://app.customervoice.com.br',
  BACKEND_URL_REFATORADO: 'https://app.customervoice.com.br/api/v1/',
  FRONT_URL: 'https://app.customervoice.com.br',
  DEBUG_MODE: false
};

export default AppConfig;
